// FaqPage.jsx
import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import styles from "./Faq.module.css";

export default function FaqPage() {
  const [faqs, setFaqs] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("ALL");
  const { user } = useAuth();
  const isAdmin = user?.role === "ADMIN" || user?.role === "SYSTEM";

  useEffect(() => {
    fetch("/api/support/faqs", { credentials: "include" })
      .then((res) => res.json())
      .then((list) => {
        setFaqs(list);
        // 최초 로딩 시 기본 카테고리 선택 (ALL 이 아니라 첫 번째 카테고리로 하고 싶으면 아래 주석 참고)
        // const firstCat = list[0]?.category;
        // if (firstCat) setSelectedCategory(firstCat);
      });
  }, []);

  const toggle = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  // 넘어온 FAQ에서 카테고리 목록 추출
  const categories = Array.from(
    new Set(faqs.map((f) => f.category || "기타"))
  );

  // 선택된 카테고리에 따라 필터링
  const filteredFaqs =
    selectedCategory === "ALL"
      ? faqs
      : faqs.filter((f) => (f.category || "기타") === selectedCategory);

  return (
    <main className={styles.page}>
      <div className={styles.header}>
        <div>
          <h1 className={styles.title}>자주 묻는 질문</h1>
          <p className={styles.subtitle}>
            많은 사용자들이 궁금해하는 질문과 답변을 모아두었습니다.
          </p>
        </div>
        {isAdmin && (
          <button
            className={styles.writeBtn}
            onClick={() => {
              /* 모달 열기 or 별도 페이지 이동 */
            }}
          >
            FAQ 등록
          </button>
        )}
      </div>

      {/* 🔹 카테고리 탭 영역 */}
      <div className={styles.tabs}>
        <button
          type="button"
          className={`${styles.tab} ${
            selectedCategory === "ALL" ? styles.activeTab : ""
          }`}
          onClick={() => setSelectedCategory("ALL")}
        >
          전체
        </button>
        {categories.map((cat) => (
          <button
            key={cat}
            type="button"
            className={`${styles.tab} ${
              selectedCategory === cat ? styles.activeTab : ""
            }`}
            onClick={() => setSelectedCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      <section className={styles.card}>
        <div className={styles.list}>
          {filteredFaqs.map((item) => (
            <div key={item.id} className={styles.item}>
              <button
                type="button"
                className={styles.question}
                onClick={() => toggle(item.id)}
              >
                <span className={styles.q}>{item.question}</span>
                <span className={styles.icon}>
                  {openId === item.id ? "▲" : "▼"}
                </span>
              </button>

              {openId === item.id && (
                <div className={styles.answer}>
                  {item.answer.split("\n").map((line, idx) => (
                    <p key={idx}>{line}</p>
                  ))}
                </div>
              )}
            </div>
          ))}

          {filteredFaqs.length === 0 && (
            <div className={styles.empty}>
              등록된 FAQ가 없습니다.
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
